<template>
	<ModalErro v-if="showModal" title-modal="Erro" :message-error="messageError" @fechar="showModal = false" />
	<div class="container">
		<div class="page-header">
			<h2>Extrato de {{ $route.query.name }}</h2>
			<div class="action-buttons">
				<router-link :to="`/alterar-senha/${$route.params.id}`" class="btn btn-primary">Alterar
					senha</router-link>
				<router-link to="/admin" class="btn btn-secondary">Voltar</router-link>
			</div>
		</div>

		<div class="stats-cards">
			<div class="stat-card">
				<h3>{{ totalLeads }}</h3>
				<p>Total últimos período selecionado</p>
			</div>
			<div class="stat-card">
				<h3>{{ totalLeadsEnviados }}</h3>
				<p>Total sincronizado período selecionado</p>
			</div>
		</div>

		<div class="linha box-data">
			<p class="linha-data">
				Local
				<select name="estado" id="estado" class="filtro-data" v-model="buscaLocal">
					<option value="">Todos</option>
					<option :value="regiao.Local" v-for="(regiao, index) in regioes" :key="index">{{ regiao.Local }}
					</option>
				</select>
			</p>
			<p class="linha-data">
				Data inicial:
				<input type="date" class="filtro-data" v-model="dataInicial" />
			</p>
			<p class="linha-data">
				Data Final:
				<input type="date" class="filtro-data" v-model="dataFinal" />
			</p>
			<p>
				<button @click="buscarLeads()" class="buttonBuscar">
					<i class="bi bi-search"></i>
					<span class="text-mobile">Buscar</span>
				</button>
			</p>
		</div>

		<div class="card">
			<div class="row">
				<h3>Leads de {{ $route.query.name }}</h3>
				<div class="box-itens-pagina">
					<label for="itensPorPagina">Itens por página: </label>
					<select id="itensPorPagina" v-model="itensPorPagina" @change="mudarItensPorPagina"
						class="filtro-data">
						<option :value="10">10</option>
						<option :value="25">25</option>
						<option :value="50">50</option>
						<option :value="100">100</option>
					</select>
				</div>
			</div>

			<div class="table-responsive">
				<table class="candidates-table">
					<thead>
						<tr>
							<th>Nome</th>
							<th>Idade</th>
							<th>Telefone</th>
							<th>Responsável</th>
							<th>Data</th>
							<th>Local</th>
							<th>Status</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(lead, index) in leads" :key="index">
							<td>{{ lead.Nome }}</td>
							<td>{{ lead.Idade }}</td>
							<td>{{ lead.Telefone }}</td>
							<td>{{ lead.Responsavel || " - " }}</td>
							<td>
								{{
									lead.Data_criacao != "" ? formatDateHour(lead.Data_criacao) : "-"
								}}
							</td>
							<td>{{ lead.Local }}</td>
							<td>
								<span class="status" :class="{ enviado: lead.Sincronizado }">
									{{ lead.Sincronizado ? "Enviado" : "Pendente" }}
								</span>
							</td>
						</tr>
					</tbody>
				</table>

				<div v-if="leads.length === 0" class="empty-state">
					<p class="margin-bottom-40px">Nenhum lead cadastrado ainda.</p>
				</div>

				<!-- Paginação -->
				<div v-if="totalLeads > 0" class="pagination">
					<div class="pagination-info">
						Mostrando {{ inicioItem }} a {{ fimItem }} de {{ totalLeads }} registros
					</div>
					<div class="pagination-controls">
						<button @click="irParaPagina(1)" :disabled="paginaAtual === 1" class="btn-pagination">
							<i class="bi bi-chevron-double-left"></i>
						</button>
						<button @click="irParaPagina(paginaAtual - 1)" :disabled="paginaAtual === 1"
							class="btn-pagination">
							<i class="bi bi-chevron-left"></i>
						</button>

						<button v-for="pagina in paginasVisiveis" :key="pagina" @click="irParaPagina(pagina)"
							:class="['btn-pagination', { active: pagina === paginaAtual }]">
							{{ pagina }}
						</button>

						<button @click="irParaPagina(paginaAtual + 1)" :disabled="paginaAtual === totalPaginas"
							class="btn-pagination">
							<i class="bi bi-chevron-right"></i>
						</button>
						<button @click="irParaPagina(totalPaginas)" :disabled="paginaAtual === totalPaginas"
							class="btn-pagination">
							<i class="bi bi-chevron-double-right"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { api } from "../services/api";
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useRoute } from 'vue-router';
import ModalErro from "../components/ModalErro.vue";

const route = useRoute();

const leads = ref([]);
const online = ref(navigator.onLine);
const dataInicial = ref("");
const dataFinal = ref("");
const buscaLocal = ref("");
const showModal = ref(false);
const messageError = ref('');
const regioes = ref([]);

// Variáveis de paginação
const paginaAtual = ref(1);
const itensPorPagina = ref(10);
const totalLeads = ref(0);
const totalPaginas = ref(0);
const totalLeadsEnviados = ref(0);

const inicioItem = computed(() => {
	if (totalLeads.value === 0) return 0;
	return (paginaAtual.value - 1) * itensPorPagina.value + 1;
});

const fimItem = computed(() => {
	const fim = paginaAtual.value * itensPorPagina.value;
	return fim > totalLeads.value ? totalLeads.value : fim;
});

const paginasVisiveis = computed(() => {
	const paginas = [];
	const maxPaginas = 5;
	let inicio = Math.max(1, paginaAtual.value - Math.floor(maxPaginas / 2));
	let fim = Math.min(totalPaginas.value, inicio + maxPaginas - 1);

	if (fim - inicio < maxPaginas - 1) {
		inicio = Math.max(1, fim - maxPaginas + 1);
	}

	for (let i = inicio; i <= fim; i++) {
		paginas.push(i);
	}

	return paginas;
});

onMounted(async () => {
	await getRegioes();
	await carregarLeads();
	window.addEventListener("online", updateOnlineStatus);
	window.addEventListener("offline", updateOnlineStatus);
});

onBeforeMount(() => {
	window.removeEventListener("online", updateOnlineStatus);
	window.removeEventListener("offline", updateOnlineStatus);
});

function updateOnlineStatus() {
	online.value = navigator.onLine;
}

async function getRegioes() {
	try {
		let res = await api.getRegioes(route.params.id);
		regioes.value = res;
	} catch (error) {
		console.log("Error", error);
		messageError.value = "Erro ao carregar regiões";
		showModal.value = true;
	}
}

async function carregarLeads() {
	try {
		// Envia página e quantidade de itens para a API
		let res = await api.getLeadsScouterAdmin(
			dataInicial.value,
			dataFinal.value,
			route.params.id,
			buscaLocal.value,
			paginaAtual.value,
			itensPorPagina.value
		);

		leads.value = res.leads || [];
		totalLeads.value = res.total || 0;
		totalLeadsEnviados.value = res.totalEnviados || 0;
		totalPaginas.value = res.totalPages;
	} catch (error) {
		console.log("Error", error);
		messageError.value = "Erro ao carregar leads";
		showModal.value = true;
	}
}

// Função chamada ao clicar no botão buscar
function buscarLeads() {
	paginaAtual.value = 1; // Reseta para primeira página ao fazer nova busca
	carregarLeads();
}

// Função para mudar página
function irParaPagina(pagina) {
	if (pagina >= 1 && pagina <= totalPaginas.value) {
		paginaAtual.value = pagina;
		carregarLeads();
	}
}

// Função para mudar itens por página
function mudarItensPorPagina() {
	paginaAtual.value = 1; // Reseta para primeira página
	carregarLeads();
}

const formatDateHour = (dateString) => {
	return new Date(dateString).toLocaleString("pt-BR", {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit'
	});
}
</script>

<style scoped>
.row {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}

@media(max-width: 768px) {
	.row {
		width: 100%;
		display: grid;
		gap: 10px;
		justify-content: space-between;
	}
}
</style>